import '../js/fontawesome/js/regular.js';
import '../js/fontawesome/js/solid.js';
import '../js/fontawesome/js/fontawesome.js';

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const howSqftWorksSwiper = new Swiper('.swiper.how-sqft-works__slider', {
    loop: true,
    modules: [Pagination, Autoplay],
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    spaceBetween: 40,
});

const testimonalsSwiper = new Swiper('.swiper.testimonals__slider', {
    loop: true,
    modules: [Autoplay],
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    spaceBetween: 40,
    breakpoints: {
        1024: {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 40,
            autoplay: false
        },
    }
});

const whatWeDoSwiper = new Swiper('.swiper.what-we-do__slider', {
    loop: true,
    modules: [Pagination, Navigation],
    spaceBetween: 40,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const teamSwiper = new Swiper('.swiper.team__slider', {
    loop: true,
    modules: [Pagination, Autoplay],
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    spaceBetween: 40,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
        1024: {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});